import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-foreground mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`block w-full rounded-md bg-popover border border-border-control px-3 py-2 text-sm text-foreground placeholder:text-[hsl(var(--fg-3,var(--muted-foreground)))] focus:outline-none focus:border-ring focus:ring-2 focus:ring-ring/40 focus:ring-offset-0 transition-colors ${
            error ? 'border-destructive focus:ring-destructive/40' : ''
          } ${className}`}
          {...props}
        />
        {error && <p className="mt-2 text-sm text-destructive">{error}</p>}
        {helperText && !error && <p className="mt-2 text-sm text-muted-foreground">{helperText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
